<template>
  <SectionContainer @edit="$emit('edit')" :hideEdit="hideEdit" :showEdit="showEditComputed" :showAdd="showAddComputed">

		<!-- Display Tagline -->
		<InfoRow :label="t('profile.tagline')" v-if="knownAs">
			<p>
				{{ knownAs }}
			</p>
		</InfoRow>

    <p v-if="achievements">
      {{ achievements }}
    </p>

    <!-- Display selected professions -->
    <InfoRow :label="t('profile.your_profession')" v-if="selectedProfessionsWithNames.length">
      <p v-for="profession in selectedProfessionsWithNames" :key="profession.key">
        <MultilanguageDisplay :value="profession.name" />
      </p>
    </InfoRow>

    <!-- Display Other Interests -->
    <InfoRow :label="t('profile.other_profession')" v-if="otherProfessions.length">
      <p v-for="profession in otherProfessions" :key="profession.key">
        {{ profession }}
      </p>
    </InfoRow>

  </SectionContainer>
</template>

<script setup>
import { computed } from "vue";
import SectionContainer from "@/components/account/sections/SectionContainer.vue";
import InfoRow from "@/components/content/InfoRow.vue";
import MultilanguageDisplay from "@/components/core/content/MultilanguageDisplay.vue";
const { t } = useI18n();

const props = defineProps({
  knownAs: {
    type: String,
    default: ''
  },
  achievements: {
    type: String,
    default: ''
  },
  selectedProfessions: {
    type: Array,
    default: () => []
  },
  otherProfessions: {
    type: Array,
    default: () => []
  },
  onboardingData: {
    type: Object,
    default: () => ({}),
  },
  showEdit: {
    type: Boolean,
    default: true
  },
  hideEdit: {
    type: Boolean,
    default: false
  },
});

// Computed properties to map selected and other professions to their corresponding names
const selectedProfessionsWithNames = computed(() => {
  if (!props.onboardingData.professions) return [];
  return props.selectedProfessions.map(selectedKey => {
    return props.onboardingData.professions.find(profession => profession.key === selectedKey) || {};
  });
});

// Computed properties to determine if showAdd and showEdit should be true or false
const showAddComputed = computed(() => {
  return !props.knownAs && !props.achievements && !selectedProfessionsWithNames.value.length && !props.otherProfessions.length;
});

const showEditComputed = computed(() => {
  return !showAddComputed.value;
});

</script>

<style scoped></style>
